module.exports = __webpack_public_path__ + "img/blue_157.c94fb7f2.png";